module.exports = __webpack_public_path__ + "img/Max Steinbok1.74724117.jpg";